module.exports = __webpack_public_path__ + "img/shanmai1.f37fe4c6.jpg";